<!-- =========================================================================================
    File Name: ProjectLayout.vue
    Description: Index layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="layout--index" :class="[layoutTypeClass, navbarClasses, footerClasses, { 'no-scroll': isAppPage }]">
    <v-nav-menu :navMenuItems="navMenuItems" title="Vuexy" parent=".layout--index" />

    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay" />

      <!-- Navbar -->
      <template>
        <the-navbar-vertical :navbarColor="navbarColor" :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]" />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">

            <!-- pc -->
            <transition v-if="this.verticalNavMenuWidth === 'default'" :name="routerTransition">
              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div class="content-area__heading" :class="{ 'pr-4 border-0 md:border-r border-solid border-grey-light': $route.meta.breadcrumb }">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb v-if="$route.meta.breadcrumb" class="ml-4 md:block hidden" :route="$route" :breadcrumb="breadcrumb" :isRTL="$vs.rtl" />
              </div>

              <div v-else-if="loadBreadCrumb.length > 0" class="router-header flex flex-wrap items-center mb-6">
                <div class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light">
                  <h2 class="mb-1">{{ loadBreadCrumbTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block" :breadcrumb="loadBreadCrumb" />
                <div v-if="loadBreadCrumbNote" class="breadcrumb-note"><img src="@/assets/icons/breadcrumb-note.svg" /> {{ loadBreadCrumbNote }}</div>
              </div>
            </transition>

            <!-- mobile -->
            <transition v-else>
              <div class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light">
                <h2 class="ml-4 mb-4">{{ loadBreadCrumbTitle }}</h2>
              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>

<script>
import BackToTop from 'vue-backtotop'
import navMenuItem1 from '@/layouts/sidemenu/project_1'
import navMenuItem3 from '@/layouts/sidemenu/project_3'
import navMenuItem4 from '@/layouts/sidemenu/project_4'
import navMenuItem5 from '@/layouts/sidemenu/project_5'
import navMenuItem6 from '@/layouts/sidemenu/project_6'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'
import themeConfig from '../../themeConfig.js'
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'

export default {
  components: {
    BackToTop,
    TheFooter,
    TheNavbarVertical,
    VNavMenu,
  },
  data() {
    return {
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: themeConfig.navbarType || "floating",
      navMenuItem: {
        '1': navMenuItem1,
        '3': navMenuItem3,
        '4': navMenuItem4,
        '5': navMenuItem5,
        '6': navMenuItem6,
      },
      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor === "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
    },
  },
  computed: {
    keyLocalStorageBoardIds() {
      const username = localStorage.getItem("login_username");
      const projectId = this.$route.params.proj_id;
      return `${username}_${projectId}_boardIds`;
    },
    menuList() {
      return this.$store.state.menu.list;
    },
    menuListByResolutions() {
      const result = [];

      const filterByResolution = (menuList) => {
        const filteredList = [];
        for (const item of menuList) {
          if ((this.isXs && this.isTrue(item.showXs)) || (this.isSm && this.isTrue(item.showSm)) ||
            (this.isMd && this.isTrue(item.showMd)) || (this.isLg && this.isTrue(item.showLg)) ||
            (this.isXl && this.isTrue(item.showXl))) {
            const newItem = { ...item }; // item 복사
            if (item.children && item.children.length > 0) {
              newItem.children = filterByResolution(item.children); // 재귀적으로 children 처리
            }
            filteredList.push(newItem);
          }
        }
        return filteredList;
      };

      if (this.menuList) {
        result.push(...filterByResolution(this.menuList));
      }

      return result;
    },

    /** 현재 화면의 너비가 xs 사이즈인지 체크 (Quasar 기준) */
    isXs() {
      return this.windowWidth < 600;
    },
    /** 현재 화면의 너비가 sm 사이즈인지 체크 (Quasar 기준) */
    isSm() {
      return this.windowWidth >= 600 && this.windowWidth < 1024;
    },
    /** 현재 화면의 너비가 md 사이즈인지 체크 (Quasar 기준) */
    isMd() {
      return this.windowWidth >= 1024 && this.windowWidth < 1440;
    },
    /** 현재 화면의 너비가 lg 사이즈인지 체크 (Quasar 기준) */
    isLg() {
      return this.windowWidth >= 1440 && this.windowWidth < 1920;
    },
    /** 현재 화면의 너비가 xl 사이즈인지 체크 (Quasar 기준) */
    isXl() {
      return this.windowWidth >= 1920;
    },
    navMenuItems() {
      if (!this.menuListByResolutions) return

      const memberInfo = this.$store.state.member.memberInfo;

      const projectId = this.$route.params.proj_id;
      /** 메뉴 권한이 있는 메뉴 */
      const boardIds = this.boardIds ? this.boardIds : [];
      /** 모든 메뉴 */
      const urlObject = JSON.parse(JSON.stringify(this.menuListByResolutions));

      // 만약 참여하고 있는 프로젝트 개수가 1개라면, "분야 바로가기" 항목은 제거한다
      if (memberInfo && memberInfo.projects && (memberInfo.projects.length || 0) === 1) {
        // url 아이템 중에서 name 값에 "바로가기" 텍스트가 있는 아이템을 제거한다
        for (let i = 0; i < urlObject.length; i++) {
          if (urlObject[i].name.includes("바로가기")) {
            urlObject.splice(i, 1);
            i--;
          }
        }
      }

      // 통합 메뉴 이동 여부
      const useBackMenu = true;
      if (useBackMenu) {
      } else {
        urlObject.splice(0, 1);
      }

      // 메뉴권한 처리
      if (urlObject) {
        for (let i = 0; i < urlObject.length; i++) {
          const useMenu = this.__useMenu__(urlObject[i], boardIds).enabled;
          if (!useMenu) {
            urlObject.splice(i, 1);
            i--;
          }
        }
      }

      const path = this.$route.path;
      const pathArray = path.split("/");
      const rootPath = pathArray.length > 2 ? `${pathArray[0]}/${pathArray[1]}/${pathArray[2]}` : "";
      this.changeRootUrl(urlObject, rootPath);
      return urlObject;
    },
    breadcrumb() {
      const breadcrumb = JSON.parse(JSON.stringify(this.$route.meta.breadcrumb));
      return breadcrumb;
    },
    loadBreadCrumb() {
      if (this.$store.state.menu.pagePath) {
        return this.$store.state.menu.pagePath;
      }
      return [];
    },
    loadBreadCrumbTitle() {
      if (this.loadBreadCrumb.length > 0) {
        return this.loadBreadCrumb[this.loadBreadCrumb.length - 1].title;
      }
      return "";
    },
    /**
     * 현재 페이지의 breadcrumb note 를 가져온다.
     * @returns {*|null}
     */
    loadBreadCrumbNote() {
      if (this.$store.state.menu.pagePath) {
        const lastItem = this.$store.state.menu.pagePath[this.$store.state.menu.pagePath.length - 1];
        if (lastItem && lastItem.note) {
          return lastItem.note;
        }
      }
      return null
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth === "default") return "content-area-reduced";
        else if (this.verticalNavMenuWidth === "reduced") return "content-area-lg";
        else return "content-area-full";
      } else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType === "hidden",
        "footer-sticky": this.footerType === "sticky",
        "footer-static": this.footerType === "static",
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.theme === "dark";
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType === "hidden",
        "navbar-sticky": this.navbarType === "sticky",
        "navbar-static": this.navbarType === "static",
        "navbar-floating": this.navbarType === "floating",
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    boardIds() {
      const boardIds = JSON.parse(localStorage.getItem(this.keyLocalStorageBoardIds));

      if (!boardIds) {
        const boardIds = [];
        //await this.$store.dispatch("member/LOAD_MEMBER_DETAIL", { project_id: this.projectId });
        if (this.$store.state.member.memberInfo) {

          const boards = this.$store.state.member.memberInfo.boards;
          if (boards && boards.length > 0) {
            for (const board of boards) {
              if (`${board.pivot.project_id}` === `${this.projectId}` && board.pivot.v === 1) {
                boardIds.push(board.id);
              }
            }
            const newBoardIds = [...new Set(boardIds)];
            this.$store.commit("menu/SET_AVAILABLE_BOARD_IDS", newBoardIds);
            localStorage.setItem(this.keyLocalStorageBoardIds, JSON.stringify(newBoardIds));
            return newBoardIds;
          } else {
            this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
          }

          this.$store.commit("menu/SET_AVAILABLE_BOARD_IDS", boardIds);
          return boardIds;
        }

        this.$store.commit("menu/SET_AVAILABLE_BOARD_IDS", boardIds);
        return boardIds;
      }

      this.$store.commit("menu/SET_AVAILABLE_BOARD_IDS", boardIds);
      return boardIds;
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const proj of projects) {
          if (proj.id == this.projectId && proj.company.length > 0) {
            const path = proj.company[0].pivot.company_path;
            const lv = path.split("/").length - 1;
            return lv;
          }
        }
      }
    },
  },
  methods: {
    isTrue(value) {
      return value === "true" || value === true;
    },
    async loadAlertList() {
      await this.$store.dispatch("approval/LOAD_NOTIFICATION_UNREAD_LIST", {
        page_unread: 1,
        per_page_unread: 5,
        days_before_unread: 30,
      });
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val === "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    setNavMenuVisibility(layoutType) {
      if ((layoutType === "horizontal" && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },
    changeRootUrl(list, rootUrl) {
      if (list && list.length > 0) {
        for (const item of list) {
          if (item.url) {
            if (typeof item.url === "string" && item.url.indexOf(rootUrl) < 0) {
              item.url = `${rootUrl}${item.url}`;
            }
          }

          if (item.submenu && item.submenu.length > 0) {
            this.changeRootUrl(item.submenu, rootUrl);
          }
        }
      }
    },

    __useMenu__(urlObject, boardIds) {
      let enabled = false
      let tab = false

      if (urlObject) {

        // submenu 가 있는 경우
        if (urlObject.submenu) {
          let allDisabledSubMenu = true;
          let tabCount = 0;
          for (let i = 0; i < urlObject.submenu.length; i++) {
            const useMenu = this.__useMenu__(urlObject.submenu[i], boardIds)
            // 권한이 있는 탭의 개수 체크
            if (useMenu.enabled && useMenu.tab) {
              tabCount++;
            }
            const enabledSubMenu = useMenu.enabled;
            if (!enabledSubMenu) {
              urlObject.submenu.splice(i, 1);
              i--;
            } else {
              allDisabledSubMenu = false;
            }
          }

          // 하나라도 활성화된 메뉴가 있거나, 하위 메뉴가 권한이 있는 탭 메뉴를 가지는 경우 상위 메뉴 활성화
          enabled = (tabCount > 0) || !allDisabledSubMenu;
        } else if (urlObject.visible === 'hide') {
          enabled = false;
        }

        // groupName 이 있는 경우
        else if (urlObject.groupName && urlObject.groupName.length > 0) {
          for (const boardId of urlObject.groupName) {
            try {
              const bid = this.__getBidWithStringBoardId(boardId);

              // 권한 체크
              if (boardIds.indexOf(Number(`${bid}`)) >= 0) {
                enabled = true
                if (urlObject.visible === 'tab') {
                  tab = true
                }
                break
              }
            } catch (e) { /*ignore*/ }

          }
        }

        // 그 외
        else {
          // 대시보드의 경우 lv1, lv2 만 사용할 수 있도록 처리
          if (urlObject.name === '대시보드' && this.getLevel > 2) {
            enabled = false;
          } else {
            enabled = true;
          }
        }
      }

      return { enabled, tab };
    },

    __getBidWithStringBoardId(boardId) {
      try {
        if (boardId.indexOf('/') >= 0) {
          return parseInt(boardId.split('/')[0]);
        } else if (boardId.indexOf('-') >= 0) {
          return parseInt(boardId.split('-')[0]);
        }
      } catch (e) {}
      return boardId;
    },
  }, // methods


  async created() {
    await this.$store.dispatch("project/LOAD_PROJECT", { project_id: this.projectId });
    const project = this.$store.state.project.projectInfo;
    if (project && project.menu_json) {
      const menu = JSON.parse(project.menu_json);
      this.$store.commit("menu/SET_MENU", menu);
    }

    await this.$store.dispatch("member/LOAD_MEMBERS_ALL", {
      projectId: this.$route.params.proj_id,
    });

    const color = this.navbarColor === "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);

    await this.$store.dispatch("member/LOAD_META", {key: 'document_field'});
  },
  mounted() {
    this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    this.loadAlertList();
  },
};
</script>

<style lang="scss">
[dir] input[readonly="readonly"] {
  background-color: #fafafa;
}

[dir] textarea[readonly="readonly"] {
  background-color: #fafafa;
}

[dir] .file-input .vs-con-input .vs-inputx {
  background-color: #ffffff;
}

[dir] .con-select .vs-select--input {
  background-color: #ffffff;
}

[dir] .vdp-datepicker input[readonly="readonly"] {
  background-color: #ffffff;
}

/* 페이지네이션 중앙 정렬 */
[dir] .vs-con-table .vs-table--pagination .vs-row .vs-col:nth-child(1) {
  display: none !important;
}

[dir] .vs-con-table .vs-table--pagination .vs-row .vs-col:nth-child(2) {
  width: 100% !important;
  justify-content: center !important;
}

/* 페이지네이션 현재페이지 색상 */
[dir] .vs-con-table .vs-table--pagination .vs-pagination-primary .effect,
[dir] .vs-con-table .vs-table--pagination .vs-pagination-primary .vs-pagination--buttons:hover {
  background: rgba(var(--vs-secondary), 1) !important;
}

/* 리스트 스타일 */
.dot {
  width: 10px;
  height: 10px;
  margin-right: 8px;
  border-radius: 10px;
  display: inline-block;
  background-color: #6670cb;
}

.dot.small {
  width: 3px;
  height: 3px;
}

.dot.red {
  background-color: #fb0000;
}

.dot.black {
  background-color: #3c3c3c;
}

.dot.yellow {
  background-color: #ffd600;
}

/* 테이블 스타일 */
ul.table {
  width: 100%;
}

ul.table > li {
  display: grid;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #cdcdcd;
  grid-template-rows: minmax(52px, 100%);
}

ul.table > li.tbody {
  background-color: #fff;
}

ul.table > li.tbody > span {
  font-weight: normal !important;
}

ul.table > li > span {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  font-weight: 500;
}

ul.table > li > span:first-child {
  border-left: none;
}

ul.table.table-2 > li {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

ul.table.table-3 > li {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

ul.table.table-4 > li {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

ul.table.table-5 > li {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

ul.table.table-6 > li {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

ul.table.table-7 > li {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

ul.table.table-8 > li {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

ul.table.table-9 > li {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

ul.table.table-10 > li {
  grid-template-columns: 50px repeat(9, minmax(0, 1fr));
}

ul.table.table-no > li {
  grid-template-columns: 60px minmax(0, 100%);
}

ul.table > li.table-2-li {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

ul.table > li.table-3-li {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

ul.table > li.table-4-li {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

ul.table > li.table-5-li {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

ul.table > li.table-6-li {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

ul.table > li.table-7-li {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

ul.table > li.table-8-li {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

ul.table > li.table-9-li {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

ul.table > li.table-10-li {
  grid-template-columns: 50px repeat(9, minmax(0, 1fr));
}

ul.table > li.table-no-li {
  grid-template-columns: 60px minmax(0, 100%);
}

.vs-row .border {
  text-align: center;
  background-color: #f9f9f9;
}

.bg-fff {
  background-color: #fff;
}

.border-left {
  border-left: 1px solid #cdcdcd !important;
}

.border-right {
  border-right: 1px solid #cdcdcd !important;
}

.border-bottom {
  border-bottom: 1px solid #cdcdcd !important;
}

.border-top {
  border-top: 1px solid #cdcdcd !important;
}

.title {
  font-weight: 500;
}

.router-header {
  padding: 0 16px;

  @media (min-width: theme("screens.xl")) {
    padding: 0;
  }
}
.breadcrumb-note {
  margin-left: 16px;
  font-size: 15px;
  color: #3c3c3c;
  font-weight: 500;
  display: flex;
  align-items: center;

  img {
    margin-right: 4px;
  }
}
</style>
